module.exports = __webpack_public_path__ + "static/media/user.589bac7c.png";